<app-top-bar [topBarTitle]="pageTitle"></app-top-bar>
<div *ngIf="hasAccessToRecordKPR; else RecordKPRNotAccessible" class="chat-container">
    <div class="warning-banner">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ warningMessage }}</span>
    </div>

    <div class="messages-area" #messagesContainer>
        <div *ngFor="let message of messages" class="message-wrapper" [ngClass]="{'user-message': message.role === ChatRole.User, 
                     'assistant-message': message.role === ChatRole.Assistant}">

            <div class="message-header" *ngIf="message.role === ChatRole.Assistant">
                <i class="fa-solid fa-robot"></i>
                <span class="message-sender">RecordKPR</span>
            </div>

            <div class="message-content" [innerHTML]="getMessageHtml(message)" (click)="onAssistantContentClick($event, message)"></div>
        </div>


        <div class="typing-indicator" *ngIf="isLoading">
            <div class="message-header">
                <i class="fa-solid fa-robot"></i>
                <span class="message-sender">RecordKPR</span>
            </div>
            <div class="typing-content">
                <span>{{ typingIndicatorText }}</span>
                <span class="dots">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                </span>
            </div>
        </div>
    </div>


    <div class="input-area">
        <div class="input-controls">
            <button pButton type="button" icon="fa-solid fa-plus" class="new-chat-btn p-button p-button-text"
                (click)="startNewChat()" [disabled]="isLoading" pTooltip="{{ newChatButtonLabel }}"
                tooltipPosition="top"></button>

            <textarea pInputTextarea [(ngModel)]="userInput" [placeholder]="placeholderText" [autoResize]="true"
                [rows]="1" (keydown.enter)="onEnterKey($event)" [disabled]="isLoading" class="chat-input">
            </textarea>

            <button pButton type="button" icon="fa-solid fa-paper-plane" (click)="sendMessage()"
                [disabled]="!userInput.trim() || isLoading" class="send-btn p-button-primary">
            </button>
        </div>
    </div>

</div>

<ng-template #RecordKPRNotAccessible>
    <app-error [errorMessage]="recordKPRAccessErrorMessage"></app-error>
</ng-template>